import React from 'react';
import { ProposalList } from '../Proposal/ProposalList';

export const ProposalsTab = () => {
  return <ProposalList />
};
